import { capitalizeFirstLetter } from './capitalizeFirstLetter';
import message_en from '../helpers/pushNotificationMessages/messages_en';
import message_ar from '../helpers/pushNotificationMessages/messages_ar';
import message_es from '../helpers/pushNotificationMessages/messages_es';
import message_fr from '../helpers/pushNotificationMessages/messages_fr';
import message_he from '../helpers/pushNotificationMessages/messages_he';
import message_it from '../helpers/pushNotificationMessages/messages_it';
import message_pt from '../helpers/pushNotificationMessages/messages_pt';

export async function pushNotificationMessage({ actionType, notifyContent, lang }) {

    const notificationMessages = {
        'en': message_en,
        'en-US': message_en,
        'ar': message_ar,
        'es': message_es,
        'fr-FR': message_fr,
        'fr': message_fr,
        'it-IT': message_it,
        'pt-PT': message_pt,
        'pt': message_pt,
        'it': message_it,
        'he': message_he
    };

    const getMessages = notificationMessages[lang ? lang?.toLowerCase() : 'en'];
    const content = await getMessages({ actionType, notifyContent });
    return {
        title: content?.title,
        message: content?.message
    };
}

export function formatAmount(amount, currency, locale) {
    let convertCurrency = 'USD';
    if (amount) {
        convertCurrency = currency ? currency : convertCurrency;
        return amount.toLocaleString(locale, { style: 'currency', currency: convertCurrency });
    } else {
        return null;
    }
}

export function formatText(text) {
    if (text) {
        let capitalizedText = capitalizeFirstLetter(text);
        return capitalizedText ? capitalizedText.trim() : '';
    }
    return '';
}